/*
 * WorldRecords Messages
 *
 * This contains all the text for the WorldRecords container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'features.WorldRecords';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'World Records',
  },
  total: {
    id: `${scope}.total`,
    defaultMessage: 'Total',
  },
  addWorldRecord: {
    id: `${scope}.addWorldRecord`,
    defaultMessage: 'Add World Record',
  },
  editWorldRecord: {
    id: `${scope}.editTestType`,
    defaultMessage: 'Update World Record',
  },
  name: {
    id: `${scope}.name`,
    defaultMessage: 'Name',
  },
  menValue: {
    id: `${scope}.menValue`,
    defaultMessage: 'Men value',
  },
  womenValue: {
    id: `${scope}.womenValue`,
    defaultMessage: 'Women value',
  },
  deleteWorldRecord: {
    id: `${scope}.deleteWorldRecord`,
    defaultMessage:
        'Are you sure you want to delete this World Record?',
  },
});
